
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-50a4658a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GroupLoan.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GroupLoan.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-50a4658a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GroupLoan.vue"),
  /* scopeId */
  "data-v-50a4658a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Loan/GroupLoan.vue
// module id = 705
// module chunks = 0